(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[770],{

/***/ 4713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiters",
      function () {
        return __webpack_require__(3837);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ Box; },
  "e": function() { return /* reexport */ SmallBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/atoms/Box/Box.tsx

var Box = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:w-10/12 px-8 py-6 rounded-3xl glass-light dark:glass-dark mb-6 drop-shadow-lg hover:drop-shadow-2xl transition-all",
        children: children
    });
};
var SmallBox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " px-8 py-6 rounded-3xl glass-light dark:glass-dark mb-6 drop-shadow-lg hover:drop-shadow-2xl transition-all",
        children: children
    });
};


;// CONCATENATED MODULE: ./components/atoms/Box/index.ts



/***/ }),

/***/ 3970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/atoms/Button/Button.tsx

var isLink = function(button) {
    return button.href !== undefined;
};
var Button = function(props) {
    var className = props.className, children = props.children;
    var href = isLink(props) ? props.href : undefined;
    var target = isLink(props) ? props.target : undefined;
    var download = isLink(props) ? props.download : false;
    var onClick = !isLink(props) ? props.onClick : undefined;
    var type = !isLink(props) ? props.type : undefined;
    var disabled = !isLink(props) ? props.disabled || false : undefined;
    var classes = "block gradient-border transition transition-300 rounded-md px-4 py-2 headline hover:gradient-bg hover:text-off-white";
    if (isLink(props)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            target: target,
            className: "".concat(classes, " ").concat(className),
            download: download,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        onClick: onClick,
        className: "".concat(classes, " ").concat(className),
        disabled: disabled,
        children: children
    });
};


;// CONCATENATED MODULE: ./components/atoms/Button/index.ts



/***/ }),

/***/ 5097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ BioDataForm; },
  "t": function() { return /* reexport */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@formspree/react/dist/formspree-react.esm.js + 4 modules
var formspree_react_esm = __webpack_require__(9080);
// EXTERNAL MODULE: ./components/atoms/Box/index.ts + 1 modules
var Box = __webpack_require__(9399);
// EXTERNAL MODULE: ./components/atoms/Button/index.ts + 1 modules
var Button = __webpack_require__(3970);
;// CONCATENATED MODULE: ./components/organisms/Form/Form.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ContactForm = function() {
    var ref = _slicedToArray((0,formspree_react_esm/* useForm */.cI)("maylwrlz"), 2), state = ref[0], handleSubmit = ref[1];
    if (state.succeeded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-green-100 px-4 py-2 text-green-600 ring-1 ring-green-600 font-bold rounded-md",
                children: "Thanks for signing up to my mailing list! I'll reach out as soon as I'm ready for my next position."
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "name",
                                    className: "flex flex-col font-bold mb-2 mt-6",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "name",
                                    type: "text",
                                    name: "name",
                                    className: "px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formspree_react_esm/* ValidationError */.p8, {
                                    prefix: "Name",
                                    field: "name",
                                    errors: state.errors
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "email",
                                    className: "flex flex-col font-bold mb-2 mt-6",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "email",
                                    type: "email",
                                    name: "email",
                                    className: "px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formspree_react_esm/* ValidationError */.p8, {
                                    prefix: "Email",
                                    field: "email",
                                    errors: state.errors
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "message",
                            className: "flex flex-col font-bold mb-2 mt-6",
                            children: "Message"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: "message",
                            name: "message",
                            className: "px-4 py-2 rounded-md my-2 ring-1 ring-grey-400 dark:ring-grey-700"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formspree_react_esm/* ValidationError */.p8, {
                            prefix: "Message",
                            field: "message",
                            errors: state.errors
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        disabled: state.submitting,
                        onClick: function(noop) {
                            return noop;
                        },
                        className: "group",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "block headline group-hover:text-off-white",
                            children: state.submitting ? "Loading ..." : "Send Message"
                        })
                    })
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./Service/utils.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var uploadFileRequest = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(formData, progressCallback) {
        var config, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    config = {
                        headers: {
                            "content-type": "multipart/form-data"
                        },
                        onUploadProgress: progressCallback,
                        validateStatus: function(status) {
                            return true;
                        }
                    };
                    console.log({
                        file: formData.get("theFiles")
                    });
                    _ctx.next = 4;
                    return axios_default().post("/api/uploads", formData, config);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uploadFileRequest(formData, progressCallback) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/organisms/Form/Biodata.form.tsx
function Biodata_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Biodata_form_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Biodata_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Biodata_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var BioDataForm = function() {
    var ref = (0,react.useState)(""), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var onChange = function() {
        var _ref = Biodata_form_asyncToGenerator(runtime_default().mark(function _callee(formData) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return uploadFileRequest(formData, function(event) {
                            setStatus("INFO");
                            setProgress(Math.round(event.loaded * 100 / event.total));
                        });
                    case 2:
                        response = _ctx.sent;
                        console.log(response);
                        if (response.status == 200) {
                            setStatus("SUCCESS");
                        }
                        if (response.status != 200) {
                            setStatus("ERROR");
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChange(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var ErrorMessage = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",
            role: "alert",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block sm:inline",
                    children: "Something went wrong file didnt uploaded please use different method!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return setStatus("");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-0 bottom-0 right-0 px-4 py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "fill-current h-6 w-6 text-red-500",
                            role: "button",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    var InfoMessage = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative",
            role: "alert",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "block sm:inline",
                    children: [
                        "Uploading (",
                        progress,
                        " %)"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return setStatus("");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-0 bottom-0 right-0 px-4 py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "fill-current h-6 w-6 text-blue-500",
                            role: "button",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    var SuccessMessage = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative",
            role: "alert",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block sm:inline",
                    children: "File Uploaded Successfully"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return setStatus("");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-0 bottom-0 right-0 px-4 py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "fill-current h-6 w-6 text-green-500",
                            role: "button",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "gap-2 flex flex-col md:flex-row",
            children: [
                "WhatsApp:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "whatsapp://send?text=&phone=:+919428356535",
                    className: "underline cursor-pointer",
                    children: "+91 9428356535"
                }),
                " ",
                "OR Email:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "mailto:hemaparikh4@gmail.com",
                    className: "underline cursor-pointer",
                    children: "hemaparikh4@gmail.com"
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./components/organisms/Form/index.tsx




/***/ }),

/***/ 3837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_atoms_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4232);
/* harmony import */ var _components_organisms_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5097);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2092);





// import { RecruiterForm } from 'Molecules/RecruiterForm';
var RecruitersPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), success = ref[0], setSuccess = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), error = ref1[0], setError = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Layout__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .A, {
        title: "Recruiter Information about Krutik Parikh",
        description: "Thank you for your interest in me for software engineering roles you are hiring for.",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "headline text-3xl md:text-5xl lg:text-6xl mt-8",
                    children: "Hi, I'm Krutik!"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "headline text-xl md:text-2xl lg:text-3xl",
                    children: "Nice to meet you."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-4 mb-4 text-lg leading-7",
                    children: "Thank you for your interest in me for the software engineering roles you are hiring for. I have created this page to save time for both of us and tell you exactly what I am looking for in my next position."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "headline text-2xl mt-8",
                    children: "Which roles are of interest to me?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "list-disc ml-4 mt-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Full-stack Developer"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Software Developer"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Mobile App Developer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "headline text-2xl mt-8",
                    children: "My preferred tech stack"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "list-disc ml-4 mt-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Javascript / Typescript"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "React.js / Next.js"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "React-Native / Expo"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Go / Node.js"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Tailwind "
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "MySQL / MongoDB "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "headline text-2xl mt-8",
                    children: "What compensation and benefits am I looking for in my next role?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "list-disc ml-4 mt-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-semibold",
                                    children: "Salary: "
                                }),
                                "\u2265$180,000 p.a."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-semibold",
                                children: "Fully Remote / Hybrid "
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Annual bonus and/or equity scheme"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Flexible work schedules "
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "Full Health Benefits "
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "21 days of P.T.O"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "mt-1",
                            children: "RRSP 5% matched"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-4 mb-4 text-lg leading-7",
                    children: "Currently, I am not looking for new opportunities. However, you can leave your contact details below and I will reach out to you when I am ready to take on a new position."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_Form__WEBPACK_IMPORTED_MODULE_3__/* .ContactForm */ .t, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RecruitersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [432,336,774,888,179], function() { return __webpack_exec__(4713); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);